import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f4xfzytua7: FaireBrandEntity = {
  token: "b_f4xfzytua7",
  type: "brand",
  name: "Speedy Monkey",
  avatarUrl:
    "https://cdn.faire.com/fastly/b68dde56cde457fd6fabb8ef58f98a8b79d797fa94fc740b54030fdb08d245ff.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/82dbe61955e4c1373402a9be88caeb63ee9b6aecf369e2fabda3dc1d39fb16d2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b68dde56cde457fd6fabb8ef58f98a8b79d797fa94fc740b54030fdb08d245ff.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/82dbe61955e4c1373402a9be88caeb63ee9b6aecf369e2fabda3dc1d39fb16d2.jpeg",
  location: "Fort Lauderdale, FL, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 149,
  isTopShop: true,
  isInsider: true,
  description:
    'We are proud to introduce you to Speedy Monkey LLC,\na new American company dedicated to the little one’s world. \n\nWith over 30 years of successful experience in the toy industry, our challenge today is to create and propose high-quality toys with entertaining, educational, and safety values.\n\nWe designed our own wooden toy collection Speedy Monkey made with FSC-certified wood via our FSC-certified manufacturing partner and non-toxic, child-safe paints, Speedy Monkey toys meet ASTM F963, California Prop 65, and international safety standards, letting children play safely and imaginatively. We offer premium toys that combine contemporary lifestyle designs adapted to traditional toys. \n\nWe also select from around the world, renowned brands for distribution across the US market, such as Moulin Roty (famous French brand that has been specialized in nursery, toy, and birth gifts since 1972), Souza costumes, Tolo Bio and Flipetz.\n\nAs Pascal BERNARD, Founder and President\nof Speedy Monkey would say:\n"Of course, a toy should have a developmental characteristic but we also take pride in making sure children have fun and let their imagination fly away..."',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:52.242Z",
    importedBy: "entity-db-cli",
  },
};
